import type { FaireProductEntity } from "../../entity_types/product";

export const p_ekm444zk35: FaireProductEntity = {
  token: "p_ekm444zk35",
  type: "product",
  name: "Detox Lotion (Lymphatic Cream)",
  brandToken: "b_c96vrxm17w",
  brandName: "Unknown Brand",
  imageUrl:
    "https://cdn.faire.com/fastly/1ad8151f306620dea0a874448d4a1b73c1cb0fdb71ee4da54d82d3fb0cdd80d0.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/78cad9088f3ac73769b7eea21e36ac10ebd3dec543a2f9633cea628d95a894b2.jpeg",
    "https://cdn.faire.com/fastly/803e906404689fa9c6239667d4f424ff62e6857ea932791635c3d38c78c0597c.jpeg",
  ],
  priceDollars: 24.94,
  description:
    "Detox Lotion is a lymphatic cream made with ingredients known to drain the lymphatic system, help improve circulation of fluid throughout the body to eliminate toxins, and help with allergies and sore throats. \n\n**Now comes in amber",
  tags: [],
  msrpDollars: 49.88,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:25:31.782Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
